import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';
import { clientsAdminRoutes } from './clients-admin/clients-admin.routes';
import { companiesAdminRoutes } from './companies-admin/companies-admin.routes';
import { paymentsAdminRoutes } from './payments-admin/payments-admin.routes';
import { quotesAdminRoutes } from './quotes-admin/quotes-admin.routes';
import { usersAdminRoutes } from './users-admin/users-admin.routes';

export const adminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    children: clientsAdminRoutes,
    path: 'clients',
  },
  {
    canActivate: [sessionGuard],
    children: companiesAdminRoutes,
    path: 'companies',
  },
  {
    canActivate: [sessionGuard],
    children: paymentsAdminRoutes,
    path: 'payments',
  },
  {
    canActivate: [sessionGuard],
    children: quotesAdminRoutes,
    path: 'quotes',
  },
  {
    canActivate: [sessionGuard],
    children: usersAdminRoutes,
    path: 'users',
  },
];
